import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  LOB_GET_REQUEST,
  LOB_GET_SUCCESS,
  LOB_GET_FAILURE,
  LOB_GET_RESET,
  LOB_LIST_REQUEST,
  LOB_LIST_SUCCESS,
  LOB_LIST_FAILURE,
  LOB_LIST_RESET,
  LOB_CREATE_REQUEST,
  LOB_CREATE_SUCCESS,
  LOB_CREATE_FAILURE,
  LOB_CREATE_RESET,
  LOB_EDIT_REQUEST,
  LOB_EDIT_SUCCESS,
  LOB_EDIT_FAILURE,
  LOB_EDIT_RESET,
  LOB_DEACTIVATE_REQUEST,
  LOB_DEACTIVATE_SUCCESS,
  LOB_DEACTIVATE_FAILURE,
  LOB_DEACTIVATE_RESET,
  LOB_EXPORT_REQUEST,
  LOB_EXPORT_SUCCESS,
  LOB_EXPORT_FAILURE,
  LOB_EXPORT_RESET,
} from './../../constants'

export function createLOB(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs`,
      method: 'POST',
      types: [
        LOB_CREATE_REQUEST,
        LOB_CREATE_SUCCESS,
        LOB_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getLOB(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs`,
      method: 'GET',
      types: [
        LOB_LIST_REQUEST,
        LOB_LIST_SUCCESS,
        LOB_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getLOBbyID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs/${id}`,
      method: 'GET',
      types: [
        LOB_GET_REQUEST,
        LOB_GET_SUCCESS,
        LOB_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editLOB(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs/${id}`,
      method: 'PUT',
      types: [
        LOB_EDIT_REQUEST,
        LOB_EDIT_SUCCESS,
        LOB_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateLOB(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs/${id}/delete`,
      method: 'PUT',
      types: [
        LOB_DEACTIVATE_REQUEST,
        LOB_DEACTIVATE_SUCCESS,
        LOB_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportLOB(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs/exports`,
      method: 'GET',
      types: [
        LOB_EXPORT_REQUEST,
        LOB_EXPORT_SUCCESS,
        LOB_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetListLOB() {
  return {
    type: LOB_LIST_RESET,
  }
}

export function resetCreateLOB() {
  return {
    type: LOB_CREATE_RESET,
  }
}

export function resetEditLOB() {
  return {
    type: LOB_EDIT_RESET,
  }
}

export function resetGetLOB() {
  return {
    type: LOB_GET_RESET,
  }
}

export function resetDeactivateLOB() {
  return {
    type: LOB_DEACTIVATE_RESET,
  }
}
export function resetExportLOB() {
  return {
    type: LOB_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/lob/lob-action.js